import React from "react";
import ReactDOM from "react-dom";
import {FeaturedGrants} from "../components/FeaturedGrants";

export const insertFeaturedGrants = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="featured-grants"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<FeaturedGrants />, element);
  });
};
